import { TweenLite, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-heroWithLink',
  content: '.js-heroWithLink-content'
}, ({ component, content }) => {
  const tween = TweenLite.to(content, 0.4, {
    delay: 0.2,
    opacity: 1,
    y: 20,
    ease: Power2.easeInOut,
    onComplete: _ => bus.emit('hero-with-link-ready'),
    paused: true
  })
  bus.on('shapes-bg-ready', _ => tween.paused(false))
})
